import { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';

export const useAuthEvents = () => {
  const { oktaAuth } = useOktaAuth();

  useEffect(() => {
    const handleTokenError = (err: Error) => {
      console.error('Token error:', err);
      oktaAuth.signOut();
    };

    const handleTokenExpired = (key: string) => {
      console.warn(`Token expired: ${key}`);
      oktaAuth.signOut(); 
    };

    oktaAuth.tokenManager.on('expired', handleTokenExpired);
    oktaAuth.tokenManager.on('error', handleTokenError);

    return () => {
      oktaAuth.tokenManager.off('expired', handleTokenExpired);
      oktaAuth.tokenManager.off('error', handleTokenError);
    };
  }, [oktaAuth]);
};
